const confirmationImport = {
    show: 'El formato excel solo debe incluir despacho y SKU',
    showIcon: './assets/icon/ico_placeholder_documentos.svg',
    exportFile: 'confirmación_despacho_proveedor.xlsx',
    paginatorAllData: true,
    columns: [
    {
      title: 'Despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchId
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.skuCode
    },
    {
      title: 'Descripción',
      name: 'skuName',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.skuName
    },
    {
      title: 'Cant. pendiente',
      name: 'pendingAmount',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.pendingAmount
    }
  ]};
  export { confirmationImport };
  